import { useEffect } from 'react';

import { useTerminalStore } from '../../../store/Terminal/useTerminalStore';
import {
  TERMINAL_SHORTCUT_CODE,
  TERMINAL_SHORTCUT_KEY,
} from '../../../utils/constants/terminalConstants';

export function isTerminalShortcut(event: KeyboardEvent): boolean {
  const isKey =
    event.key === TERMINAL_SHORTCUT_KEY ||
    event.code === TERMINAL_SHORTCUT_CODE;
  return (
    isKey && event.ctrlKey && !event.metaKey && !event.altKey && !event.shiftKey
  );
}

export function useTerminalShortcut(): void {
  useEffect(() => {
    const onKeyDown = (event: KeyboardEvent) => {
      if (!isTerminalShortcut(event)) {
        return;
      }
      event.preventDefault();
      useTerminalStore.getState().toggleDrawer();
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, []);
}
